import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import logoDark from '../assets/images/logo-dark.png'
import logoLight from '../assets/images/logo-light.png'


type NavbarProps = {
    navLight: boolean;
    bgLight: boolean;
    playBtn?: boolean;
    navCenter?: boolean;
}

export default function Navbar({navLight, bgLight, playBtn} : NavbarProps) {
    let [scroll, setScroll] = useState<Boolean>(false)

    useEffect(()=>{

        const handlerScroll=()=>{
            if(window.scrollY > 50){
                setScroll(true)
            }else{setScroll(false)}
        }

        window.addEventListener('scroll',handlerScroll)
        return () => {
        window.removeEventListener('scroll',handlerScroll)
        };
    })

  return (
        <nav className={`navbar ${bgLight ? 'bg-white dark:bg-slate-900 shadow dark:shadow-gray-800' : ''} ${scroll ? 'is-sticky' : '' }`} id="navbar">
            <div className="container relative flex flex-wrap items-center justify-between">
                {!navLight && 
                    <Link className="navbar-brand md:me-8" to="/">
                        <img src={logoDark} className="h-14 inline-block dark:hidden" alt=""/>
                        <img src={logoLight} className="h-14 hidden dark:inline-block" alt=""/>
                    </Link>
                }
                {navLight && 
                    <Link className="navbar-brand" to="/">
                        <span className="inline-block dark:hidden">
                            <img src={logoDark} className="l-dark" alt=""/>
                            <img src={logoLight} className="l-light" alt=""/>
                        </span>
                        <img src={logoLight} className="hidden dark:inline-block" alt=""/>
                    </Link>
                }
                 
            </div>
        </nav>
  )
}
